import React from "react";
import { useAppSelector } from "../../../store/hooks";
import { StateroomSelector } from "../components/crew/StateroomSelector";
import { selectIsBreakaway } from "../../../store/selectors/breakawayHullSelectors";
import BreakawayStateroomStep from "./BreakawayStateroomStep";

/**
 * Step 11: Staterooms & Living Spaces
 * Configure staterooms, double occupancy, low berths, emergency low berths, and common areas per Traveller rules.
 * Includes summary of tonnage, cost, and power.
 */
const StateroomStep: React.FC = () => {
  // Check if breakaway hulls are configured
  const isBreakaway = useAppSelector(selectIsBreakaway);
  const breakawayHull = useAppSelector((state) => state.breakawayHull);
  const hasBreakawayHulls = isBreakaway || breakawayHull?.isBreakaway;

  // If breakaway hulls are detected, render the breakaway version
  if (hasBreakawayHulls) {
    return <BreakawayStateroomStep />;
  }

  return (
    <div className="pb-32">
      <h2 className="text-2xl font-bold mb-4 text-highlightOrange dark:text-orange-400">
        Staterooms & Living Spaces
      </h2>
      <StateroomSelector />
      {/* Summary is handled by StateroomSelector for now. */}
    </div>
  );
};

export default StateroomStep;
